import { render, staticRenderFns } from "./AdminEntityItemCreate.vue?vue&type=template&id=2f0efd60&scoped=true"
import script from "./AdminEntityItemCreate.vue?vue&type=script&lang=js"
export * from "./AdminEntityItemCreate.vue?vue&type=script&lang=js"
import style0 from "./AdminEntityItemCreate.vue?vue&type=style&index=0&id=2f0efd60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0efd60",
  null
  
)

export default component.exports